<template>
  <select-input :value="value"
                @input="input"
                :options="transports"
                label="name"
                :label-renderer="renderLabel"
                :disabled="disabled"
                code="id"></select-input>
</template>

<script>
import SelectInput from "@/components/controls/selectInput/SelectInput";
export default {
  name: "select-transport",
  components: {
    SelectInput
  },
  props: {
    value: {
      type: String,
      default: undefined
    },
    firstAsDefault: {
      type: Boolean,
      default: false
    },
    passTransports: {
      type: Array,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      transports: []
    }
  },
  methods: {
    input(selectedFactory) {
      this.$emit('input', selectedFactory)
      this.$emit('change', this.factories.find(d => d.id === selectedFactory));
    },
    renderLabel(option) {
      return option ? option.name : null
    }
  },
  async mounted() {
    let transports = [];
    if (this.passTransports === null) {
      transports = await this.$store.dispatch('pigletTransport/fetchAll');
    } else {
      transports = this.passTransports
    }
    this.transports = transports;
    if(this.firstAsDefault && this.factories.length > 0) {
      this.$emit('input', this.transports[0].id);
      this.$emit('change', this.transports[0]);
    }
    this.$emit('transportsLoaded', this.transports);
  },
  watch: {
    passTransports() {
      this.transports = this.passTransports
    }
  }
}
</script>

<style scoped>

</style>
